import { render, staticRenderFns } from "./DemonstrativoFaturamentoCard.vue?vue&type=template&id=6a587d31&scoped=true&"
import script from "./DemonstrativoFaturamentoCard.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoFaturamentoCard.vue?vue&type=script&lang=js&"
import style0 from "./DemonstrativoFaturamentoCard.vue?vue&type=style&index=0&id=6a587d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a587d31",
  null
  
)

export default component.exports